<script>
	import { tooltip } from "../actions/tooltip";

	export let tooltipText = null;
	export let iconClass = "fa-info-circle";
</script>

<span class="info-tooltip" title={tooltipText} use:tooltip>
	<i class="fa {iconClass}"></i>
</span>

<style>
	span.info-tooltip {
		margin-left: 2px;
	}
</style>
